export const makeRequirements = (hasNps, hasSentiment, numericalFields, queries, queryLimit) => {
    let blocks = [
        {
            aggfuncs: [
                {
                    new_column: 'frequency',
                    src_column: 'document_id',
                    aggfunc: 'count',
                }
            ],
        }
    ];
    // get NPS
    if (hasNps) {
        blocks.push({
            aggfuncs: [
                {
                    new_column: 'frequency',
                    src_column: 'document_id',
                    aggfunc: 'count',
                }
            ],
            pivot_field: 'NPS Category',
            metric_calculator: 'nps',
        });
    }
    // get sentiment
    if (hasSentiment) {
        blocks.push({
            aggfuncs: [
                {
                    new_column: 'frequency',
                    src_column: 'document_id',
                    aggfunc: 'count',
                }
            ],
            pivot_field: 'sentiment__',
            metric_calculator: 'sentiment',
        });
    }
    // get numerics
    if (numericalFields?.length) {
        blocks.push(...numericalFields.map(field => ({
            aggfuncs: [
                {
                    new_column: `${field}|count`,
                    src_column: `${field}`,
                    aggfunc: 'count',
                },
                {
                    new_column: `${field}|mean__`,
                    src_column: `${field}`,
                    aggfunc: 'mean',
                }
            ],
            metric_calculator: 'mean_impact'
        })));
    }
    let queryList = queries ?? [];
    if (queryLimit !== false) {
        queryList = queries.slice(0, queryLimit);
    }
    return {
        blocks,
        queries: queryList.map((q) => ({
            name: q.name,
            value: {
                excludes: q.query_value.excludes,
                includes: q.query_value.includes,
                type: q.query_value.type ?? 'match_all',
            }
        })),
    };
};
